import React, { Component } from 'react';

class BarChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data,
      width: props.width,
      height: props.height,
      margin: props.margin,
      yMin: props.yMin,
      yMax: props.yMax,
      yIncrement: props.yIncrement,
      stackedBarChart: props.stackedBarChart
    };
  }

  componentDidMount() {
    this.loadD3();
  }

  componentDidUpdate() {
    this.loadD3();
  }

  loadD3() {
    if (!window.d3) {
      const script = document.createElement('script');
      script.src = 'https://d3js.org/d3.v7.min.js';
      script.async = true;
      document.body.appendChild(script);
      script.onload = () => {
        this.renderChart();
      };
    } else {
      this.renderChart();
    }
  }

  renderChart() {
    let { data, width, height, margin, stackedBarChart, yMin, yMax, yIncrement } = this.state;
    yMin = parseFloat(yMin);
    yMax = parseFloat(yMax);
    yIncrement = parseFloat(yIncrement);
    const svg = d3.select(this.refs.svg);
    if (!data) {
        return null;
    }
    svg.selectAll("*").remove();

    // Define color scale
    const color = d3.scaleOrdinal()
        .domain(['positive', 'neutral', 'negative'])
        .range(['#4CAF50', '#FFC107', '#F44336']);

    // Set up the scales
    const xScale = d3.scaleBand()
        .domain(data.map(d => d.category))
        .range([margin.left, width - margin.right])
        .padding(0.2);

    // If a max value is set, use custom scale
    let yScale;
    if(yMax) {
        yScale = d3.scaleLinear()
            .domain([yMin, yMax])
            .range([height - margin.bottom, margin.top]);
    } else {
        yScale = d3.scaleLinear()
            .range([height - margin.bottom, margin.top]);
        if (stackedBarChart) {
            const maxStackValue = d3.max(data, d => d3.sum(d.values, v => v.value));
            yScale.domain([0, maxStackValue]);
        } else {
            yScale.domain([0, d3.max(data, d => d.value)]);
        }
    }

    // Set up the axes
    const xAxis = d3.axisBottom(xScale);
    let yAxis = d3.axisLeft(yScale);
    if(yIncrement) {
        yAxis.ticks((yMax - yMin) / yIncrement); // Set the tick increment
    }

    // Add the axes to the SVG
    svg.append('g')
        .attr('transform', `translate(0, ${height - margin.bottom})`)
        .call(xAxis)
        .selectAll("text")
        .style("text-anchor", "end")
        .attr("dx", "-0.8em")
        .attr("dy", "0.15em")
        .attr("transform", "rotate(-45)");

    svg.append('g')
        .attr('transform', `translate(${margin.left}, 0)`)
        .call(yAxis);

    if (stackedBarChart) {
        // Create a stack generator
        const stack = d3.stack()
            .keys(['positive', 'neutral', 'negative'])
            .value((d, key) => d.values.find(v => v.type === key)?.value || 0);

        const series = stack(data);

        // Add stacked bars to the SVG
        svg.selectAll('g.layer')
            .data(series)
            .enter()
            .append('g')
            .attr('class', 'layer')
            .attr('fill', d => color(d.key))
            .selectAll('rect')
            .data(d => d)
            .enter()
            .append('rect')
            .attr('x', d => xScale(d.data.category))
            .attr('y', d => yScale(d[1]))
            .attr('height', d => yScale(d[0]) - yScale(d[1]))
            .attr('width', xScale.bandwidth());
    } else {
        // Add unstacked bars to the SVG
        const bars = svg.selectAll('rect')
            .data(data);

        bars.enter()
            .append('rect')
            .attr('x', d => xScale(d.category))
            .attr('y', d => yScale(d.value))
            .style("fill", "#ff0000")
            .attr('width', xScale.bandwidth())
            .attr('height', d => height - margin.bottom - yScale(d.value));

        bars.transition()
            .attr('x', d => xScale(d.category))
            .attr('y', d => yScale(d.value))
            .attr('width', xScale.bandwidth())
            .attr('height', d => height - margin.bottom - yScale(d.value));
    }
}

  render() {
    return (
        <svg ref="svg" width={this.state.width} height={this.state.height}></svg>
    );
  }
}

export default BarChart;